__turbopack_context__.v({
  "root": "IconButton-module-scss-module__klokKW__root",
});
